import { memo } from 'react';
import { Group, Circle, Ellipse, Line, Rect } from 'react-konva';

export const BlondeBallerina = memo(function BlondeBallerina({ x, y, scaleX, scaleY, rotation, opacity, fill, customColors, leftArmAngle, rightArmAngle, leftLegAngle, rightLegAngle, onClick, onDragEnd, onTransformEnd, draggable, isSelected }) {
  const c = customColors || {};
  const skinColor = c.skinColor || '#fde8d0';
  const hairColor = c.hairColor || '#f5d060';
  const hairDark = '#d4a830';
  const dressColor = c.dressColor || fill || '#f9a8d4';
  const tutuColor = c.dressColor || '#f472b6';
  const tutuLight = '#fbcfe8';
  const shoeColor = c.shoeColor || '#ec4899';
  const eyeColor = c.eyeColor || '#3b82f6';
  const lipColor = '#f87171';
  const cheekColor = '#fca5a5';

  const la = leftArmAngle || 0;
  const ra = rightArmAngle || 0;
  const ll = leftLegAngle || 0;
  const rl = rightLegAngle || 0;

  return (
    <Group
      x={x} y={y}
      scaleX={scaleX || 1} scaleY={scaleY || 1}
      rotation={rotation || 0}
      opacity={opacity ?? 1}
      draggable={draggable}
      onClick={() => onClick?.()}
      onTap={() => onClick?.()}
      onDragEnd={(e) => onDragEnd?.({ x: e.target.x(), y: e.target.y() })}
      onTransformEnd={(e) => {
        const node = e.target;
        onTransformEnd?.({ x: node.x(), y: node.y(), scaleX: node.scaleX(), scaleY: node.scaleY(), rotation: node.rotation() });
      }}
    >
      <Ellipse x={0} y={72} radiusX={22} radiusY={5} fill="#000" opacity={0.15} />

      {/* Left leg - animated */}
      <Group rotation={ll} x={-6} y={38}>
        <Line points={[0,0, -2,20]} stroke={skinColor} strokeWidth={5} lineCap="round" />
        <Line points={[-2,20, -4,30]} stroke="#fce4ec" strokeWidth={5} lineCap="round" />
        <Ellipse x={-6} y={32} radiusX={7} radiusY={3.5} fill={shoeColor} />
      </Group>

      {/* Right leg - animated */}
      <Group rotation={rl} x={6} y={38}>
        <Line points={[0,0, 2,20]} stroke={skinColor} strokeWidth={5} lineCap="round" />
        <Line points={[2,20, 4,30]} stroke="#fce4ec" strokeWidth={5} lineCap="round" />
        <Ellipse x={6} y={32} radiusX={7} radiusY={3.5} fill={shoeColor} />
      </Group>

      {/* Tutu */}
      <Ellipse x={0} y={36} radiusX={28} radiusY={8} fill={tutuLight} opacity={0.6} />
      <Ellipse x={0} y={34} radiusX={26} radiusY={7} fill={tutuColor} opacity={0.7} />
      <Ellipse x={0} y={32} radiusX={24} radiusY={6} fill={dressColor} opacity={0.8} />
      <Line points={[-26,34, -22,38, -16,35, -10,38, -4,35, 2,38, 8,35, 14,38, 20,35, 24,38, 28,34]}
        stroke={tutuColor} strokeWidth={1.5} lineCap="round" tension={0.4} />

      {/* Body */}
      <Rect x={-10} y={10} width={20} height={24} fill={dressColor} cornerRadius={4} />
      <Line points={[-8,12, 0,15, 8,12]} stroke={tutuColor} strokeWidth={1} lineCap="round" tension={0.3} />

      {/* Left arm - animated */}
      <Group rotation={la} x={-10} y={16}>
        <Line points={[0,0, -12,-8, -18,-16]} stroke={skinColor} strokeWidth={4.5} lineCap="round" lineJoin="round" />
        <Circle x={-18} y={-16} radius={3} fill={skinColor} />
      </Group>

      {/* Right arm - animated */}
      <Group rotation={ra} x={10} y={16}>
        <Line points={[0,0, 12,-8, 18,-16]} stroke={skinColor} strokeWidth={4.5} lineCap="round" lineJoin="round" />
        <Circle x={18} y={-16} radius={3} fill={skinColor} />
      </Group>

      {/* Neck */}
      <Rect x={-3} y={2} width={6} height={10} fill={skinColor} />

      {/* Head */}
      <Circle x={0} y={-10} radius={16} fill={skinColor} />

      {/* Hair back */}
      <Ellipse x={0} y={-18} radiusX={17} radiusY={10} fill={hairColor} />
      <Ellipse x={-13} y={-12} radiusX={5} radiusY={8} fill={hairColor} rotation={-15} />
      <Ellipse x={13} y={-12} radiusX={5} radiusY={8} fill={hairColor} rotation={15} />

      {/* Bun */}
      <Circle x={0} y={-28} radius={8} fill={hairColor} />
      <Circle x={0} y={-28} radius={6} fill={hairDark} opacity={0.3} />
      <Line points={[-4,-26, 0,-24, 4,-26]} stroke={shoeColor} strokeWidth={2} lineCap="round" tension={0.5} />
      <Line points={[-3,-24, -6,-21]} stroke={shoeColor} strokeWidth={1.5} lineCap="round" />
      <Line points={[3,-24, 6,-21]} stroke={shoeColor} strokeWidth={1.5} lineCap="round" />

      {/* Face */}
      <Ellipse x={-9} y={-5} radiusX={4} radiusY={3} fill={cheekColor} opacity={0.25} />
      <Ellipse x={9} y={-5} radiusX={4} radiusY={3} fill={cheekColor} opacity={0.25} />
      <Ellipse x={-6} y={-11} radiusX={4} radiusY={4.5} fill="white" />
      <Circle x={-6} y={-10} radius={2.5} fill={eyeColor} />
      <Circle x={-5} y={-11} radius={1} fill="white" />
      <Ellipse x={6} y={-11} radiusX={4} radiusY={4.5} fill="white" />
      <Circle x={6} y={-10} radius={2.5} fill={eyeColor} />
      <Circle x={7} y={-11} radius={1} fill="white" />
      <Line points={[-10,-13, -9,-15]} stroke="#333" strokeWidth={0.8} lineCap="round" />
      <Line points={[-3,-14, -3,-16]} stroke="#333" strokeWidth={0.8} lineCap="round" />
      <Line points={[3,-14, 3,-16]} stroke="#333" strokeWidth={0.8} lineCap="round" />
      <Line points={[10,-13, 9,-15]} stroke="#333" strokeWidth={0.8} lineCap="round" />
      <Line points={[-9,-15, -6,-16.5, -3,-15]} stroke={hairDark} strokeWidth={1} lineCap="round" tension={0.4} />
      <Line points={[3,-15, 6,-16.5, 9,-15]} stroke={hairDark} strokeWidth={1} lineCap="round" tension={0.4} />
      <Circle x={0} y={-6} radius={1} fill="#e8c4a0" />
      <Line points={[-4,-2, -2,-0.5, 0,-1, 2,-0.5, 4,-2]} stroke={lipColor} strokeWidth={1.5} lineCap="round" tension={0.4} />

      {isSelected && <Circle x={0} y={20} radius={55} stroke="#f472b6" strokeWidth={1.5} dash={[6,4]} fill="transparent" opacity={0.4} />}
    </Group>
  );
});
